import styled from '@emotion/styled'
import * as React from 'react'

import { Space } from '../..'

export const MasterDetailPageView = styled.div`
  display: flex;
  justify-content: stretch;
  background: var(--White98);
  height: 100%;
  overflow: hidden;
`

export type MasterDetailStyleProps = {
  detailBackground?: string
  masterBackground?: string
  size?: string
}

export const MasterPage = styled.div<MasterDetailStyleProps>`
  min-width: 430px;
  width: ${props => props.size};
  background: ${props => props.masterBackground};
  height: 100%;
  overflow: auto;
`
export const DetailPage = styled.div<MasterDetailStyleProps>`
  flex-grow: 1;
  padding: 0;
  overflow-y: auto;
  top: 0;
  background: ${props => props.detailBackground};
  height: 100%;
`

export type MasterDetailProps = {
  detailBackground?: 'transparent' | 'white' | 'white98'
  detailChildren?: React.ReactNode
  masterBackground?: 'transparent' | 'white' | 'white98'
  masterChildren?: React.ReactNode
  width?: 'narrow' | 'normal' | 'wide' | 'extrawide' | 'half' | 'content'
}

export function MasterDetail({
  detailBackground,
  detailChildren,
  masterBackground,
  masterChildren,
  width
}: MasterDetailProps) {
  let widthSize = '500px'
  if (width === 'normal') {
    widthSize = '400px'
  } else if (width === 'narrow') {
    widthSize = '400px'
  } else if (width === 'wide') {
    widthSize = '600px'
  } else if (width === 'extrawide') {
    widthSize = '710px'
  } else if (width === 'half') {
    widthSize = '50%'
  } else if (width === 'content') {
    widthSize = 'fit-content'
  }

  let masterBackgroundTone = 'var(--White)'
  if (masterBackground === 'transparent') {
    masterBackgroundTone = 'var(--Transparent)'
  } else if (masterBackground === 'white') {
    masterBackgroundTone = 'var(--White)'
  } else if (masterBackground === 'white98') {
    masterBackgroundTone = 'var(--White98)'
  }

  let detailBackgroundTone = 'var(--Transparent)'
  if (detailBackground === 'transparent') {
    detailBackgroundTone = 'var(--Transparent)'
  } else if (detailBackground === 'white') {
    detailBackgroundTone = 'var(--White)'
  } else if (detailBackground === 'white98') {
    detailBackgroundTone = 'var(--White98)'
  }

  return (
    <MasterDetailPageView>
      <MasterPage masterBackground={masterBackgroundTone} size={widthSize}>
        <Space px={5}>{masterChildren}</Space>
      </MasterPage>
      <DetailPage detailBackground={detailBackgroundTone}>{detailChildren}</DetailPage>
    </MasterDetailPageView>
  )
}
